import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.styl';
import CuratedCard from './CuratedCard';

const CuratedCards = props => (
  <div className={`${styles.curatedCards} container`}>
    <div>
      <h2 className="header-description">Curated content to fully understand our platform</h2>
    </div>

    <div>
      {props.cards.map(category => (
        <CuratedCard key={category.id} category={category} />
      ))}
    </div>
  </div>
);

CuratedCards.defaultProps = {
  cards: []
};

CuratedCards.propTypes = {
  cards: PropTypes.array.isRequired
};

export default CuratedCards;
